"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getPrecision = function getPrecision(inputNumber) {
  var e = 1;

  while (Math.round(inputNumber * e) / e !== inputNumber) {
    e *= 10;
  }

  return Math.ceil(Math.log(e) / Math.LN10);
};

var _default = getPrecision;
exports["default"] = _default;